import React from 'react';
import ReactDOM from 'react-dom/client';
// Design tokens + theme layer (Spec 7.1) — load vars & theme overrides first,
// then Tailwind, then our base reset (so it wins over preflight where they meet).
import './styles/tokens/colors.css';
import './styles/tokens/typography.css';
import './styles/tokens/spacing.css';
import './styles/themes.css';
import './index.css';
import './styles/tokens/base.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
